import { Box, Container, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <Box
      id="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        zIndex: 1000,
        background: "linear-gradient(135deg, #0b1021, rgba(11, 16, 33, 0.85))",
        borderTop: "1px solid rgba(255, 255, 255, 0.1)",
        color: "text.primary",
        padding: { xs: 1, sm: 2 },
        boxShadow: "0 -12px 32px rgba(0, 0, 0, 0.45)",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          gap: { xs: 1, sm: 0 },
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: { xs: "center", sm: "left" } }}
        >
          &copy; {currentYear} {t("footer.copyright")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
          }}
        >
          <Link
            href="https://musicrandomizer.com/"
            target="_blank"
            color="inherit"
            sx={{ textAlign: "center" }}
          >
            MusicRandomizer
          </Link>
          <Link
            href="https://musictierlist.com/"
            target="_blank"
            color="inherit"
            sx={{ textAlign: "center" }}
          >
            MusicTierList
          </Link>
          <Link
            href="https://musicbrackets.com/"
            target="_blank"
            color="inherit"
            sx={{ textAlign: "center" }}
          >
            MusicBrackets
          </Link>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link href="/about" color="inherit" sx={{ textAlign: "center" }}>
            About
          </Link>
          <Link href="/blog" color="inherit" sx={{ textAlign: "center" }}>
            Blog
          </Link>
          <Link href="/contact" color="inherit" sx={{ textAlign: "center" }}>
            Contact
          </Link>
          <Link href="/terms" color="inherit" sx={{ textAlign: "center" }}>
            Terms
          </Link>
          <Link href="/privacy-policy" color="inherit" sx={{ textAlign: "center" }}>
            {t("footer.privacyPolicy")}
          </Link>
          <Link href="/cookie-policy" color="inherit" sx={{ textAlign: "center" }}>
            {t("footer.cookiePolicy")}
          </Link>
          <Link
            href="https://x.com/musicrandomized"
            target="_blank"
            color="inherit"
            sx={{ textAlign: "center" }}
          >
            X (Twitter)
          </Link>
        </Box>
      </Container>
    </Box>
  );
}
